export const SETTINGS = {
  SERVICE_LINKAGE_PATH: '/setting/service-linkage',
  NETSUITE_INTEGRATION_PATH: '/setting/netsuite-integration',
}
